import '../main.less';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Textarea from '../../../../shared/form-elements/textarea';
import Input from '../../../../shared/form-elements/input';
import getProcessedLinks from '../../../shared/processLinks';

const Form = props => {
	const { isNeedUseTextArea, canBeEdited, index } = props;
	const hasProcessedLinks = props.initialValues[props.fieldName]
		&& getProcessedLinks(props.initialValues[props.fieldName]).length;

	return (
		<div
			className={`payout-request-edit-cell-form ${isNeedUseTextArea && 'wide'} ${index === 0 && 'top-row'}`}
		>
			{!!hasProcessedLinks && <p>{getProcessedLinks(props.initialValues[props.fieldName])}</p>}
			<form
				className="ui-form payouts-form__main clearfix display-flex"
				onSubmit={props.handleSubmit(data => {
					props.updatePayoutRequest(props.row.id, data);
				})}
			>
				<Field
					name={props.fieldName}
					placeholder={props.intl(`Change ${props.fieldName}`)}
					component={isNeedUseTextArea ? Textarea : Input }
					className={'width-100-p'}
				/>
				{
					canBeEdited &&
					<button
						className="checkbox-submit hover-pointer"
					/>
				}
			</form>
		</div>
	);
};

export default reduxForm({})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/forms/edit-payout-requests-form-value/main.js